<template>
    <div id="newsletter">
        <span v-if='language === "nl" && !formSubmitted'
              class="bold">Blijf op de<br>Hoogte</span>
        <span v-else-if='language === "en" && !formSubmitted'
              class="bold">Stay up to<br>date</span>
        <span v-if='language === "nl" && formSubmitted'
              class="bold">U bent geabonneerd op de nieuwsbrief</span>
        <span v-else-if='language === "en" && formSubmitted'
              class="bold">Successfully subscribed to Newsletter</span>
        <div class='form'>
            <input v-if='language === "nl" && !formSubmitted'
                   type="text"
                   v-model='firstName'
                   size="40"
                   placeholder="Voornaam">
            <input v-else-if='language === "nl" && !formSubmitted'
                   type="text"
                   v-model='lastName'
                   size="40"
                   placeholder="Naam">
            <input v-if='language === "en" && !formSubmitted'
                   type="text"
                   v-model='firstName'
                   size="40"
                   placeholder="First Name">
            <input v-else-if='language === "en" && !formSubmitted'
                   type="text"
                   v-model='lastName'
                   size="40"
                   placeholder="Last Name">
            <input v-if='language === "nl" && !formSubmitted'
                   type="email"
                   v-model='email'
                   placeholder="Emailadres">
            <input v-else-if='language === "en" && !formSubmitted'
                   type="email"
                   v-model='email'
                   placeholder="Email adress">
            <input v-if='language === "nl" && !formSubmitted'
                   type='submit'
                   @click='send'
                   value="verstuur">
            <input v-else-if='language === "en" && !formSubmitted'
                   type='submit'
                   @click='send'
                   value="send">
        </div>
    </div>
</template>

<script>
const MAIL_URL =
  'http://datastudio-eindhoven.nl/wp-content/themes/data_studio-2016-07-20-15-23-saltpond/subscribe.php?email='
export default {
  name: 'dsMailingList',
  props: ['language'],
  data() {
    return {
      email: '',
      firstName: '',
      lastName: '',
      formSubmitted: false
    }
  },
  methods: {
    send() {
      console.log(this.firstName)
      console.log(this.lastName)
      this.$http
        .get(
          MAIL_URL +
            encodeURI(this.email) +
            '&first=' +
            encodeURI(this.firstName) +
            '&last=' +
            encodeURI(this.lastName)
        )
        .then(
          response => {
            console.log(response)
            this.formSubmitted = true
            this.firstName = ''
            this.lastName = ''
            this.email = ''
          },
          response => {
            console.error(response)
          }
        )
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';

.form {
  position: relative;
  top: 1px;
  p {
    margin-bottom: 0;
  }
  input[type='email'],
  input[type='text'] {
    position: relative;
    top: 3px;
    //    background: red;
    outline: none;
    border: 0;
    margin-bottom: $baseline;
    border: 1px solid $secondary-color;
    height: 3 * $baseline;
    width: 100%;
    font-size: $small-text;
    padding-left: 0.5em;
  }
  input[type='submit'] {
    top: 3px;
    position: relative;
    border: 1px solid $secondary-color;
    margin-bottom: $baseline * 2;
    height: 3 * $baseline;
    line-height: 2 * $baseline;
    background: $secondary-color;
    color: $background-color;
    font-size: $small-text !important;
    width: 100%;
    &:hover {
      background: $high-light;
      border: 1px solid $high-light;
      cursor: pointer;
    }
  }
  .screen-reader-response {
    display: none;
  }
  span[role='alert'] {
    font-size: $x-small-text;
    color: red;
    margin-top: $baseline;
    display: block;
  }
  .wpcf7-validation-errors {
    border: none !important;
    line-height: 3 * $baseline;
    height: 3 * $baseline;
    color: red;
  }
}

#newsletter {
  margin-bottom: $baseline;
  color: $secondary-color;
}
</style>



// WEBPACK FOOTER //
// dsMailingList.vue?7c0617a4